import {
  useTranslation,
  Col,
  useShowToastNotification,
  ENotificationType,
  TRtkErrorType,
} from '@packages/utils';
import { useTheme } from 'styled-components';
import { EIconNames, Icon } from 'components/Base/Icon';
import { useDeleteMeetingMutation } from 'redux/apiSlice/elcs.slice';
import { TRemoveMeetingProps } from './RemoveMeeting.types';

const RemoveMeeting = ({
  meetingId,
  elcId,
  disabled = false,
}: TRemoveMeetingProps) => {
  const theme = useTheme();
  const { showToastNotification } = useShowToastNotification();
  const { t } = useTranslation({
    keyPrefix:
      'descriptions.admin-portal.elcs.detail.meetings-tab.list.actions.delete',
  });
  const [deleteMeeting, { isLoading }] = useDeleteMeetingMutation();

  const handleSubmit = async (e: { preventDefault: () => void }) => {
    if (disabled || isLoading) {
      e.preventDefault();
      return;
    }
    try {
      const payload: any = {
        meetingId,
      };

      if (elcId) {
        const sanitizedElcId = elcId.replace(/"/g, '');
        payload.elcId = sanitizedElcId;
      }

      await deleteMeeting(payload).unwrap();
      showToastNotification({
        message: t('SUCCESS_MESSAGE'),
        type: ENotificationType.SUCCESS,
      });
    } catch (err) {
      showToastNotification({
        message: (err as TRtkErrorType)?.data?.message,
        type: ENotificationType.ERROR,
      });
    }
  };

  return (
    <Col onClick={disabled ? undefined : handleSubmit}>
      <Icon
        icon={EIconNames.DELETE_OUTLINED}
        color={disabled ? '#B5B5B5' : theme.colorBlackIconColor}
        className={disabled ? '' : 'pointer'}
        tooltip={{
          title: disabled
            ? 'Global meetings can only be deleted from the All ELCs page'
            : t('DELETE_TOOLTIP'),
        }}
      />
    </Col>
  );
};

export default RemoveMeeting;
